import styles from './FJVideoUpload.module.less';
import FJLocalStore from '../../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useRef, useState } from 'react';
import UploadBorderHoverIcon from '../../../../assets/svg/upload-border-hover.svg?react';
import UploadBorderIcon from '../../../../assets/svg/upload-border.svg?react';
import ReUploadIcon from '../../../../assets/svg/re-upload.svg?react';
import FJCancelIcon from '../../../../assets/svg/aiGeneratorVideo/cancel.svg?react';
import FJVideoIcon24 from '../../../../assets/svg/aiGeneratorVideo/video-24px.svg?react';
import FJVideoIcon32 from '../../../../assets/svg/aiGeneratorVideo/video-32px.svg?react';
import FJVideoPreviewBox from '../../FJVideoPreviewBox/FJVideoPreviewBox';
import FJUtil from '../../../../util/FJUtil';
import { useEffect } from 'react';
const FJVideoUpload = props => {
    const {
        mediaInfo = {},
        uploadFile,
        defaultIcon,
        uploadText = 'upload-video',
        leftBottomIcon,
        className,
        uploadTextClassName,
        openMediaLibrary,
        style,
        acceptFile,
        onDelete,
        label,
        previewVideoStyle,
        autoPreview,
        uploadTitle,
    } = props;
    const { src: mediaUrl } = mediaInfo;
    const inputRef = useRef(null);
    const [isDraggingFile, setIsDraggingFile] = useState(false);
    const previewBoxRef = useRef(null);
    useEffect(() => {
        if (autoPreview) {
            _onPreviewBoxClick();
        }
    }, [autoPreview, mediaInfo]);
    const _onUploadMedia = e => {
        const file = e.target.files[0];
        uploadFile(file);
        e.target.value = null;
    };

    const _onClick = () => {
        if (window.isEditPage && openMediaLibrary) {
            openMediaLibrary();
        } else if (inputRef.current) {
            inputRef.current.click();
        }
    };
    const _onDragOver = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(true);
    };

    const _onDragLeave = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
    };

    const _onDragDrop = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
        let files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            uploadFile(file);
        }
    };

    const _onDelete = e => {
        e.stopPropagation();
        e.preventDefault();
        onDelete();
    };

    const _onPreviewBoxClick = () => {
        mediaUrl && previewBoxRef.current && previewBoxRef.current.showPreviewBox();
    };

    return (
        <div
            className={classNames(styles.box, mediaUrl ? styles.has_img : '', className)}
            onDragOver={_onDragOver}
            onDrop={_onDragDrop}
            onDragLeave={_onDragLeave}
            style={style}
            onClick={_onPreviewBoxClick}
        >
            {mediaUrl ? (
                <>
                    <video className={styles.preview_img} src={mediaUrl} alt='' loading='lazy' controls={false} />
                    <div className={classNames(styles.blur_mask, isDraggingFile ? styles.dragging : '')}>
                        {isDraggingFile && <ReUploadIcon />}
                        <span className={styles.reupload_text}>
                            {isDraggingFile ? FJLocalStore._('replace') : FJLocalStore._('change-image')}
                        </span>
                    </div>
                    {label && <div className={styles.label}>{label}</div>}
                    <div className={styles.delete_icon} onClick={_onDelete}>
                        <FJCancelIcon />
                    </div>

                    <div className={styles.video_icon_box}>
                        {leftBottomIcon ? (
                            leftBottomIcon
                        ) : (
                            <div className={styles.video_icon}>
                                <FJVideoIcon24 />
                            </div>
                        )}
                    </div>
                </>
            ) : (
                <div className={classNames(styles.blank_box, isDraggingFile ? styles.dragging : '')} onClick={_onClick}>
                    {defaultIcon ? defaultIcon : <FJVideoIcon32 />}
                    {uploadTitle && (
                        <span className={classNames(styles.upload_title)}>{FJLocalStore._(uploadTitle)}</span>
                    )}
                    <span className={classNames(styles.blank_text, uploadTextClassName)}>
                        {FJLocalStore._(uploadText)}
                    </span>
                    <UploadBorderHoverIcon className={styles.upload_border_hover} />
                    <UploadBorderIcon className={styles.upload_border} />
                </div>
            )}

            <input
                type='file'
                ref={inputRef}
                className={styles.file_input}
                accept={acceptFile}
                onChange={_onUploadMedia}
            />

            <div className={styles.dragging_mask}></div>
            {mediaInfo?.duration && <div className={styles.duration}>{FJUtil.formatTime(mediaInfo?.duration)}</div>}
            <FJVideoPreviewBox
                ref={previewBoxRef}
                videoInfo={mediaInfo}
                className={classNames(styles.preview_box)}
                style={previewVideoStyle}
            />
        </div>
    );
};
FJVideoUpload.propTypes = {
    mediaInfo: PropTypes.object,
    uploadFile: PropTypes.func,
    defaultIcon: PropTypes.node,
    uploadText: PropTypes.string,
    leftBottomIcon: PropTypes.node,
    className: PropTypes.string,
    uploadTextClassName: PropTypes.string,
    openMediaLibrary: PropTypes.func,
    onDelete: PropTypes.func,
    previewVideoStyle: PropTypes.object,
};

export default FJVideoUpload;
